import { api } from "../api/requests";

// Get All Loans
export async function getAllLoans(pageNumber?: number, pageSize?: number, offset?: number, paged?: boolean, search?: string, sort?: { sorted: boolean, unsorted: boolean }, unpaged?: boolean): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/loans?pageNumber=${pageNumber}&pageSize=${pageSize}${offset ? `&offset=${offset}` : ''}${paged ? `&paged=${paged}` : ''}${search ? `&search=${search}` : ''}${sort ? `&sort.sorted=${sort?.sorted}&sort.unsorted=${sort?.unsorted}` : ''}${unpaged ? `&unpaged=${unpaged}` : ''}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get Loan By Id
export async function getLoanById(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/loans/${id}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Delete Loan By Id
export async function deleteLoanById(id: number): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.delete(`admin/loans/${id}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Approve Loan
export async function approveLoan(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/loans/${id}/approve`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}


// Mark Loan as Paid
export async function markLoanAsPaid(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/loans/${id}/mark-paid`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Reject Loan
export async function rejectLoan(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.delete(`admin/loans/${id}/reject`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get All Approved Loans
export async function getAllApprovedLoans(pageNumber?: number, pageSize?: number, offset?: number, paged?: boolean, search?: string, sort?: { sorted: boolean, unsorted: boolean }, unpaged?: boolean): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/loans/approved?pageNumber=${pageNumber}&pageSize=${pageSize}${offset ? `&offset=${offset}` : ''}${paged ? `&paged=${paged}` : ''}${search ? `&search=${search}` : ''}${sort ? `&sort.sorted=${sort?.sorted}&sort.unsorted=${sort?.unsorted}` : ''}${unpaged ? `&unpaged=${unpaged}` : ''}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get All Approved Loans
export async function getAllCustomerLoans(customerId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/loans/customer/${customerId}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get all paid loans
export async function getAllPaidLoans(): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/loans/paid`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get all loans by product type
export async function getAllLoansByProductType(productType: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/loans/product-type/${productType}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}